import createDocumentResource from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import { IsNotEmpty, IsNumber, IsString } from 'class-validator';
import { logout } from 'src/actions/auth/authSlice';
import { LookupResults, LookupDebuggerBasic } from './lookupDebuggerBasicResource';
import { LookupDebuggerDetailed } from './lookupDebuggerDetailedResource';
import * as sharedTypes from 'src/actions/shared/sharedTypes';
import { toastError } from 'src/actions/toast';
import { translateErrors } from 'src/adapters/validateType';
import { Unauthorized, RequestTimeout, DomainError as StandardDomainError } from '@ad-scripts/application/lib/error';

export class LookupDebuggerAutolinking {
  basicCollector?: LookupDebuggerBasic;
  detailedCollector?: LookupDebuggerDetailed;
  suggestions: [];
  validationErrors: [];
}

export class DetailedRequest {
  @IsString()
  @IsNotEmpty()
  url: string;
  payload: {
    lookupLevel: string;
    uniqueMatchRequired: boolean;
    query: { [k: string]: any };
  };
}

export class LookupDebugResponse {
  adapterError: any;
  @IsNumber()
  @IsNotEmpty()
  statusCode: string;
  rawResponse: string;
  payload: {
    results: LookupResults[];
  };
}

export const lookupDebuggerAutolinkingResource = createDocumentResource<LookupDebuggerAutolinking>({
  name: 'debugAutolinkingLookup',
  endpoint: '/v1/orgs/:orgId/customer-auto-extensions/integrations/:integrationId/debug-info',
  type: LookupDebuggerAutolinking,
  observerCreator: emptyObserverCreator,
  reducers: {
    fetchStarted(state) {
      state.loadingState = 'loading';
    },
    fetchSuccess(state, action) {
      state.loadingState = 'succeeded';
      state.value = action.payload;
    },
    fetchError(state, action) {
      state.loadingState = 'failed';
      state.errors = action.payload;
    },
    fetchRequestError(state, action) {
      state.loadingState = 'failed';
      state.errors = action.payload;
    },
    reset(state) {
      state.loadingState = 'unstarted';
      state.value = {};
      state.errors = [];
    },
    timeoutError(state) {
      state.loadingState = 'failed';
      state.errors = [{ code: 'timeout' }];
    },
  },
  initialValue: {},
});

const fetchAutolinkingDebugging: sharedTypes.AppThunk =
  (urlParams, payload) =>
  async (dispatch, getState, { gateways }) => {
    try {
      dispatch(lookupDebuggerAutolinkingResource.actions.fetchStarted({}));
      const result = await gateways.autolinkingLookupDebugging.fetchAutolinkingDebugging(urlParams, payload);
      dispatch(lookupDebuggerAutolinkingResource.actions.fetchSuccess(result));
    } catch (err) {
      dispatch(toastError(`There was an error fetching debug data.`));
      if (err instanceof StandardDomainError) {
        dispatch(lookupDebuggerAutolinkingResource.actions.fetchError(translateErrors(err.errors)));
      } else if (err instanceof RequestTimeout) {
        dispatch(lookupDebuggerAutolinkingResource.actions.timeoutError({}));
      } else if (err instanceof Unauthorized) {
        dispatch(logout());
      } else {
        dispatch(lookupDebuggerAutolinkingResource.actions.fetchRequestError(translateErrors((err as any).errors)));
      }
    }
  };

const unload: sharedTypes.AppThunk = () => dispatch => {
  dispatch(lookupDebuggerAutolinkingResource.actions.reset({}));
};

lookupDebuggerAutolinkingResource.effects.fetchAutolinkingDebugging = fetchAutolinkingDebugging;
lookupDebuggerAutolinkingResource.effects.unload = unload;

export default lookupDebuggerAutolinkingResource;
